import * as angular from 'angular';

import { AlarmRowViewModel, Pattern } from '../../../models';
import { searchCriteria as identifierSearchCriteria } from '../../../components/identifierSearchBar/identifier.searchCriteria';

export const alarmsSearchCriteria: Pattern<AlarmRowViewModel>[] =
    identifierSearchCriteria
        .map(s => {
            const copy: Pattern<AlarmRowViewModel> = angular.copy(s) as any;
            copy.isMatch = (d: AlarmRowViewModel, regex: RegExp) => {
                return s.isMatch(d.identifier, regex);
            };
            return copy;
        })
        .concat(
            [
                {
                    label: 'Severity',
                    placeholder: 'Search pattern on severity',
                    model: 's',
                    property: 's',
                    isMatch: (d, regex) => {
                        return regex.test(d.viewModel.level);
                    }
                }
            ]);